import React, { useState, useContext } from 'react';
import { DATABASE_MAIN } from '../contexts/api';
import { useTranslation } from "react-i18next";
import "../localization/i18n";
import RentalAction from './RentalAction';
import RentalConfirm from './RentalConfirm';

import AuthContext from "../contexts/auth";

export const ActionInfo = (state) => {
  const { t } = useTranslation();
  if (state === "1") {
    return t("rentRENTED");
  } else {
    return t("rentFREE");
  }
};

export const ActionConfirmInfo = (state) => {
  const { t } = useTranslation();
  if (state === "1") {
    return t("back");
  } else {
    return t("rent");
  }
};

export const ActionColor = (state) => {
  if (state === "1") {
    return "danger";
  } else {
    return "primary";
  }
};

const RentalItem = (props) => {
  const { t } = useTranslation();
  const authCtx = useContext(AuthContext);
  const [actionIsShown,setActionIsShown] = useState(false);
  const [confirmIsShown,setConfirmIsShown] = useState(false);

  const onShowActionHandler = () => {setActionIsShown(true);};
  const onShowConfirmHandler = () => {setConfirmIsShown(true);};
  const onCloseActionHandler = (item) => {setActionIsShown(false); props.onAction(item);};
  const onCloseConfirmHandler = (item) => {setConfirmIsShown(false); props.onAction(item);};

  return (
    <div className="card col-md-3">
      <div className="bg-primary text-white text-center align-center mt-2">
        {t("position")}: {props.sourceItem.place}
      </div>
      <img
        className="rounded mx-auto p-2"
        src={`${DATABASE_MAIN}rentalImage.php?id=${props.sourceItem.id}`}
        alt={props.sourceItem.name}
      />
      <div className="card-header bg-primary bg-opacity-75">
        <h2 className="card-title anton text-center text-light">{props.sourceItem.name}</h2>
        <p className="card-text">{props.sourceItem.description}</p>
      </div>
      <div className="card-body">
        {props.sourceItem.state === "1"  && <div className="card-text ">{props.sourceItem.rentier}</div>}
        {props.sourceItem.state === "1"  && <div className="card-text">{props.sourceItem.fromDate}</div>}
        {props.sourceItem.state === "1"  && <div className="card-text">{t("lastTime")}: {props.sourceItem.lastRentier}</div>}
        {props.sourceItem.state === "0"  && <div className="card-text">{t("lastTime")}: {props.sourceItem.lastRentier}</div>}
        {props.sourceItem.state === "0"  && <div className="card-text">{props.sourceItem.fromDate} - {props.sourceItem.toDate}</div>}
      </div>
      <div className="card-body mx-auto">
        {authCtx.admin === "1" && <button className="btn btn-primary" onClick={onShowActionHandler}>{ActionInfo(props.sourceItem.state)}</button>}
        <button className={`btn btn-${ActionColor(props.sourceItem.state)}`} onClick={onShowConfirmHandler}>
          {ActionConfirmInfo(props.sourceItem.state)}
        </button>
      </div>
      {actionIsShown && <RentalAction item={props.sourceItem} onClose={onCloseActionHandler} />}
      {confirmIsShown && <RentalConfirm item={props.sourceItem} onClose={onCloseConfirmHandler} />}
    </div>
  );
};

export default RentalItem;
